import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { User } from 'src/app/domain/user';
import { UserService } from 'src/app/services/user.service';
import { StringTool } from '../../mapping/string.tool';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { EUserType } from 'src/app/domain/enum/user-type';
import { StringConverter } from '../string-converter';
import { SimpleListModel } from 'src/app/model/simple-list-model';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-user-box',
    templateUrl: './user-box.component.html',
    styleUrl: './user-box.component.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatButtonModule, PreventDoubleClickDirective, FormsModule, MatSelectModule, MatOptionModule, MatSlideToggleModule]
})
export class UserBoxComponent implements OnInit, AfterContentInit {
	public ValidEmail = new UntypedFormControl('', Validators.compose([
		Validators.required,
		Validators.pattern(/([a-zA-Z0-9_.+-]+)@([a-zA-Z0-9-\.]+)(\.[a-zA-Z0-9]{2,3})/),
        Validators.pattern(/([a-zA-Z0-9_.+-]{5}@(eurofins.com|etfr.eurofins.com))|([a-zA-Z0-9.]*@(?!eurofins.com|etfr.eurofins.com)).*/)]));
	Model: User = new User();
	IsCreation: boolean = true;
    public UserTypeList: SimpleListModel[] = Object.values(EUserType)
        .filter(x => !isNaN(Number(x)))
        .map(x => {
            const slm = new SimpleListModel();
            slm.idx = x as number;
            slm.s = StringConverter.getUserTypeName(x as EUserType);
            return slm;
        });
		
	constructor(
		public dialogRef: MatDialogRef<UserBoxComponent>,
		private userService: UserService,
		@Inject(MAT_DIALOG_DATA) public data: any) {
		if (data) {
			this.Model = Object.assign({}, data);
			this.IsCreation = false;
		}
	}
	ngOnInit(): void {
	}

	ngAfterContentInit(): void {
		this.ValidEmail.markAsTouched();
		if (!this.IsCreation) {
			this.ValidEmail.disable();
		}
	}

	search() {
		this.userService.searchEIMASUser(this.Model.Email).subscribe(x => {
			if (x) {
				this.Model = x
			}
		})
	}

	CanSave() {
		return StringTool.isNotNullOrEmpty(this.Model.FirstName)
			&& StringTool.isNotNullOrEmpty(this.Model.LastName)
			&& StringTool.isNotNullOrEmpty(this.Model.Email);
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onConfirm() {
		if (this.CanSave())
			this.dialogRef.close(this.Model);

	}

	public compareUserWith(m1: User, m2: User) {
		return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
	}
}
